import React from 'react';
import MicroEntry from '../micro-entry';
import MarketFlow from '../market-flow';
import Container from '@/components/container';

function CollectMicroJoin() {
  return (
    <Container
      margin={{ horizontal: false, bottom: false, top: true }}
      padding
      style={{ backgroundColor: '#FAFAFA', borderRadius: '8px' }}
    >
      <MicroEntry />
      <MarketFlow />
    </Container>
  );
}

export default CollectMicroJoin;
